import { BaseService } from "../../../../../core/services/base.service";

export interface Client {
  id: string;
  name: string;
  website?: string;
  primaryContact?: string;
  primaryPhoneNumber?: string;
  primaryEmail?: string;
  isActive: boolean;
  deleted: boolean;
}

export class ClientsService {
  static async GetAll(
    companyId: string,
    params?: { page?: number; size?: number; sort?: string; filter?: string }
  ): Promise<{ content: Client[]; totalElements: number }> {
    const query = params
      ? `?${new URLSearchParams(params as Record<string, string>).toString()}`
      : "";
    return await BaseService.Get(`/companies/${companyId}/clients${query}`);
  }
}
